export enum Column {
  MAIN = 'data-table-main',
  FLEX = 'data-table-flex',
  WIDTH_70PX = 'data-table-width-70px',
  WIDTH_80PX = 'data-table-width-80px',
  WIDTH_90PX = 'data-table-width-90px',
  WIDTH_120PX = 'data-table-width-120px',
  WIDTH_140PX = 'data-table-width-140px',
  WIDTH_160PX = 'data-table-width-160px',
  WIDTH_260PX = 'data-table-width-260px',
  ACTIONS = 'data-table-actions',
  ROWSELECT = 'data-table-rowselect',
}
